import { School } from '../school';
import { ClassType } from '../class-type';
export class ReservationPriority {
    constructor(
        public id?: number,
        public priority?: number,
        public anticipationDays?: number,
        public school?: School,
        public classType?: ClassType,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority.model.ts